module.exports = __webpack_public_path__ + "media/images/homes/Group2_150-cce5534d310e1a6b1c5c5690c9678191.png";